var _g, _g2, _rect, _g3, _rect2, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgValidatedPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 560,
    height: 380,
    viewBox: "0 0 560 380",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "PDF/UA document with a validation checkmark") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 66,
    width: 496,
    height: 266,
    rx: 20,
    fill: "#FFF1E8",
    stroke: "#DED3C5",
    strokeWidth: 3
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    stroke: "#DED3C5",
    strokeWidth: 12,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68 108h376M68 137h354M68 166h285M68 195h218"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 364,
    y: 44,
    width: 140,
    height: 46,
    rx: 10,
    fill: "#A27A5F"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(379 58)",
    stroke: "#FFF8F1",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 18V0h6a4.5 4.5 0 0 1 0 9H0M15 18V0h4c11 0 11 18 0 18h-4M32 18V0h10M32 8h8M48 20l7-22M62 0v12c0 8 11 8 11 0V0M79 18l6-18 6 18M81 12h8M97 9h6M110 18V0l-4 4"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 244,
    width: 436,
    height: 54,
    rx: 27,
    fill: "#DEEEE2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m87 271 9 9 17-22",
    stroke: "#357653",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M137 265h177",
    stroke: "#619A7D",
    strokeWidth: 9,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M137 280h96",
    stroke: "#93BAA3",
    strokeWidth: 7,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValidatedPdf);
export default __webpack_public_path__ + "static/media/validated-pdf.77dc03ceaa8010646d3ede965de1770e.svg";
export { ForwardRef as ReactComponent };